import type { ReactNode } from 'react';
import { pointText, type TimelinePoint } from './timeline';
import './requests.css';

/** One point of a question's correspondence: when, what, who and the days — read-only. */
export function PointLine({ point, mine = false, as = 'li' }: { point: TimelinePoint; mine?: boolean; as?: 'li' | 'div' }) {
  const t = pointText(point, mine);
  const Tag = as;
  return (
    <Tag className="tl-point" data-kind={point.kind}>
      {t.when && <span className="tl-when">{t.when}</span>}
      <span className="tl-what">
        <strong>{t.title}</strong>
        {t.who && ` — ${t.who}`}
      </span>
      {t.detail && <span className="tl-detail">{t.detail}</span>}
    </Tag>
  );
}

/** Points oldest first, read-only. */
export function TimelineList({ points, mine = false, label }: { points: readonly TimelinePoint[]; mine?: boolean; label?: string }) {
  return (
    <ol className="tl-list" aria-label={label}>
      {points.map((p) => (
        <PointLine key={p.id} point={p} mine={mine} />
      ))}
    </ol>
  );
}

/**
 * Owner 2026-10-30 21:38: the earlier points of a question folded under „Historia (N)” — history, never edited. Nothing
 * when there are none.
 */
export function HistoryFold({ points, mine = false, children }: { points: readonly TimelinePoint[]; mine?: boolean; children?: ReactNode }) {
  if (points.length === 0) return null;
  return (
    <details className="tl-fold">
      <summary>Historia ({points.length})</summary>
      <TimelineList points={points} mine={mine} />
      {children}
    </details>
  );
}

/** The newest point (the editable decision) and the earlier ones (history) of a timeline. */
export function splitTimeline(points: readonly TimelinePoint[] | undefined): { latest: TimelinePoint | null; earlier: TimelinePoint[] } {
  if (!points || points.length === 0) return { latest: null, earlier: [] };
  return { latest: points[points.length - 1]!, earlier: points.slice(0, -1) };
}
